import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      padding: theme.spacing(4),
    },
    progress: {
      width: 'auto !important',
      display: 'flex',
      justifyContent: 'center',
    },
    loading: {
      maxWidth: 100,
    },
    text: {
      textAlign: 'center',
    },
  }),
);

export default useStyles;
